import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router';

import { connect } from 'react-redux';
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import HairProfile from 'Apps/Prescription/Components/HairProfile';
import IntroHero from 'Apps/Prescription/Components/IntroHero';

import ErrorContainer from 'Containers/ErrorContainer';

import consultationCategoryProp from 'PropTypes/consultationProps';

import ConsultationLoading from '../Scenes/ConsultationLoading';
import QuestionLayout from '../Scenes/QuestionLayout';

import { skincareScoring } from 'assets/content/consultation/consultation';
import { consultationScoringImages } from 'assets/content/prescription/content';

import { trackGoalSelectorPrescriptionChanged } from 'dux/tracking/actions';
import * as consultationSelectors from 'dux/consultation/selectors';
import { getUserFirstName } from 'dux/user/selectors';
import * as consultationThunks from 'dux/consultation/thunks';

const useGetScoringSkincare = () => {
  const dispatch = useDispatch();
  const status = useSelector(consultationSelectors.getSkincareScoringStatus);
  const error = useSelector(consultationSelectors.getSkincareScoringError);
  const scores = useSelector(consultationSelectors.getSkincareScoringData);

  const fetchSkincareScoring = () => dispatch(consultationThunks.fetchSkincareScoring());

  useEffect(() => {
    if (status === 'idle') {
      fetchSkincareScoring();
    }
  }, [status]);

  return { error, fetchSkincareScoring, scores, status };
};

const ScoringSkincareContainer = ({ consultationCategory, onScoringSelectChange }) => {
  const navigate = useNavigate();
  const { error, fetchSkincareScoring, scores, status } = useGetScoringSkincare();
  const userFirstName = useSelector(getUserFirstName);

  if (status === 'idle' || status === 'loading') {
    return <ConsultationLoading noSurroundingStyle />;
  }

  if (status === 'error') {
    return (
      <ErrorContainer
        error={error}
        retry={fetchSkincareScoring}
        sentryMessage="Invalid state on scoring skincare"
      />
    );
  }

  return (
    <QuestionLayout
      addFooter
      consultationCategory={consultationCategory}
      showProgressTracker={false}
      submit={() => navigate('/consultation/skincare/results/ingredients')}
      tipContent={null}
    >
      <IntroHero
        description={skincareScoring.subtitle}
        imageSet={consultationScoringImages}
        title={skincareScoring.title(userFirstName)}
      >
        <HairProfile
          onScoringSelectChange={onScoringSelectChange}
          scoring={scores}
          scoringContent={{ getGoalValue: skincareScoring.getGoalValue }}
        />
      </IntroHero>
    </QuestionLayout>
  );
};

ScoringSkincareContainer.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  onScoringSelectChange: PropTypes.func.isRequired,
};

export default connect(null, {
  onScoringSelectChange: trackGoalSelectorPrescriptionChanged,
})(ScoringSkincareContainer);
